module.exports = __webpack_public_path__ + "img/win_item16.b210bf54.png";